// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ButtonSpinner_spinner__sNQju","lds-ring":"ButtonSpinner_lds-ring__9oAWt"};